export function TestEtas() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <div style={{ padding: '1rem', backgroundColor: '#005691', color: 'white' }}>
        <h2 style={{ margin: 0 }}>Test: ETAS eHandbook (Public, No Auth)</h2>
        <p style={{ margin: '0.5rem 0 0 0', fontSize: '0.9rem' }}>
          URL: https://docs.etas.com/ehandbook/ehandbook/index.html
        </p>
      </div>
      <iframe
        src="https://docs.etas.com/ehandbook/ehandbook/index.html"
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-storage-access-by-user-activation allow-top-navigation-by-user-activation"
        allow="storage-access"
        title="ETAS eHandbook Test"
        style={{ 
          flex: 1, 
          border: 'none', 
          width: '100%',
          height: '100%'
        }}
      />
    </div>
  );
}
